import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Drawer, Typography, Button, CircularProgress } from '@material-ui/core'
import NotificationItem from './NotificationItem'

const NotificationDrawer = ({ open, onClose, url, onCountChange }) => {
  const [notifications, setNotifications] = React.useState([])
  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    if (open) {
      setLoading(true)
      axios.get(`${url}/api/bid-estimation/notifications`).then(res => {
        setNotifications(res.data.notifications || [])
        if (onCountChange) onCountChange(res.data.unreadCount || 0)
        setLoading(false)
      }).catch(err => {
        console.error('Failed to fetch notifications:', err)
        setLoading(false)
      })
    }
  }, [open])

  const handleMarkRead = (id) => {
    axios.put(`${url}/api/bid-estimation/notifications/${id}/read`).then(() => {
      setNotifications(prev => prev.map(n =>
        n._id === id ? { ...n, read: true, readAt: new Date().toISOString() } : n
      ))
      const newUnread = notifications.filter(n => n._id !== id && !n.read).length
      if (onCountChange) onCountChange(newUnread)
    }).catch(err => console.error('Failed to mark read:', err))
  }

  const handleMarkAllRead = () => {
    axios.put(`${url}/api/bid-estimation/notifications/read-all`).then(() => {
      setNotifications(prev => prev.map(n => ({ ...n, read: true, readAt: new Date().toISOString() })))
      if (onCountChange) onCountChange(0)
    }).catch(err => console.error('Failed to mark all read:', err))
  }

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <div style={{ width: 360, padding: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <Typography variant="h6" style={{ fontWeight: 600, fontSize: 16 }}>Notifications</Typography>
          <Button size="small" onClick={handleMarkAllRead} style={{ textTransform: 'none', fontSize: 11 }}>
            Mark all read
          </Button>
        </div>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: 20 }}>
            <CircularProgress size={20} />
          </div>
        ) : notifications.length === 0 ? (
          <Typography variant="body2" color="textSecondary" style={{ padding: 16, textAlign: 'center' }}>
            No notifications.
          </Typography>
        ) : (
          notifications.map(n => (
            <NotificationItem key={n._id} notification={n} onMarkRead={handleMarkRead} />
          ))
        )}
      </div>
    </Drawer>
  )
}

const mapStateToProps = (state) => ({
  url: state.url
})

export default connect(mapStateToProps)(NotificationDrawer)
